import React, { useState, useEffect, useRef, useCallback } from "react"
import * as bodyScrollLock from "body-scroll-lock"
import Link from "../link"
import CrateSize from "./crate-size"
import { ReactComponent as Close } from "@svgs/close.svg"
import { useProductStore } from "@src/hooks/useStore"

const CrateSizeModal = ({ toggle, isOpen, items, quizLink }) => {
  const popupRef = useRef()

  const { currentVariant } = useProductStore(["currentVariant"]);

  const [activeIndex, setActiveIndex] = useState(1)

  const setActiveItem = useCallback(
    index => {
      setActiveIndex(index)
    },
    [activeIndex]
  )

  useEffect(() => {
    if (popupRef.current) {
      if (isOpen) {
        bodyScrollLock.disableBodyScroll(popupRef.current, { allowTouchMove: () => true })
        popupRef.current.querySelector('div > div > button').focus();
      } else {
        bodyScrollLock.enableBodyScroll(popupRef.current)
      }
    }
  }, [isOpen])

  useEffect(() => {
    if (currentVariant) {
      const matchingItem = items?.find(item => item?.label === currentVariant?.size)?._key;
      const fallbackItem = items?.[0]?._key;

      setActiveIndex(matchingItem || fallbackItem);
    }
  }, [currentVariant])

  return (
    <div
      ref={popupRef}
      className={`fixed top-0 right-0 bottom-0 left-0 flex px-2 sm:px-8 z-[60] ${
        isOpen ? `` : `hidden`
      }`}
      role="dialog"
      aria-labelledby="sizePopupHeading"
      aria-describedby="sizePopupLabel"
    >
      <div
        className="absolute top-0 left-0 z-10 w-full h-full bg-black opacity-25"
        onClick={toggle}
      ></div>
      <div className="relative z-20 m-auto bg-white rounded-xl max-h-screen max-w-[800px]">
        <div className="h-full max-h-screen overflow-x-hidden overflow-y-auto scrolling-touch">
          <div className="p-5 sm:p-8 flex flex-col gap-5">
            <div className="flex w-full sm:justify-center items-center">
              <h2 className="w-full text-center text-2xl font-medium text-dark-navy tracking-normal" id="sizePopupHeading">
                Want to compare sizes?
              </h2>
              <button
                className="ml-auto p-2.5 rounded-full shadow transition transition-opacity ease-in-out hover:opacity-50"
                onClick={toggle}
                aria-label="Close Popup"
              >
                <Close widht={16} height={16} />
              </button>
            </div>
            <div className="flex items-center w-full flex-wrap sm:flex-nowrap">
              {items?.map((item, index) => (
                <button className={`flex w-1/2 sm:w-full justify-center items-center border-b-2 ${
                    activeIndex === item?._key || activeIndex === index ? 'border-black' : 'border-gray'
                  }`} 
                  onClick={() => setActiveItem(item?._key ? item?._key : index)}
                  key={`size-${index}`}>
                  <p className="p-3 font-medium text-lg">
                    {item.label}
                  </p>
                </button>
              ))}
              </div>
            <div className="mb-4">
              {items?.map((item, index) => (
                <CrateSize
                  {...{ index, ...item, isOpen: activeIndex === item?._key || activeIndex === index }}
                  key={`carteSize-${index}`}
                  item={item}
                ></CrateSize>
              ))}
            </div>

            <footer className="text-center">
              <div className="w-full flex justify-center items-center">
                <p className="text-black text-base">Need help determining the right size dog crate for your pup?
                  <Link className="ml-1 sizing-request cursor-pointer underline" href={ quizLink } target="_blank">Take the quiz</Link>
                </p>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CrateSizeModal


